/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Open_IntegrationsInputs */

const cs_social_export_open_integrations = /** @type {(inputs: Social_Export_Open_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít integrace`)
};

const en_social_export_open_integrations = /** @type {(inputs: Social_Export_Open_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Integrations`)
};

/**
* | output |
* | --- |
* | "Open Integrations" |
*
* @param {Social_Export_Open_IntegrationsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_open_integrations = /** @type {((inputs?: Social_Export_Open_IntegrationsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Open_IntegrationsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_open_integrations(inputs)
	return cs_social_export_open_integrations(inputs)
});